import { Link } from "react-router-dom";
import { Mountain } from "lucide-react";

export function Logo({ size = "md", showIcon = true }) {
    const text = size === "lg" ? "text-2xl" : size === "sm" ? "text-base" : "text-lg";
    const iconSize = size === "lg" ? "h-6 w-6" : size === "sm" ? "h-4 w-4" : "h-5 w-5";
    return (
        <Link
            to="/"
            className="group inline-flex items-center gap-2.5"
            data-testid="site-logo"
            aria-label="Alpen Reinigung Startseite"
        >
            {showIcon && (
                <span className="relative inline-flex items-center justify-center h-9 w-9 rounded-lg border border-white/[0.12] bg-[rgba(46,168,255,0.08)]">
                    <Mountain
                        className={`${iconSize} text-[#7BD3FF]`}
                        strokeWidth={1.8}
                    />
                </span>
            )}
            <span className="flex flex-col leading-none">
                <span
                    className={`font-heading font-semibold tracking-tight text-chrome ${text}`}
                >
                    Alpen Reinigung
                </span>
                <span className="hidden sm:inline-block mt-0.5 font-mono text-[10px] uppercase tracking-[0.2em] text-[#7BD3FF]/80">
                    Innsbruck · Tirol
                </span>
            </span>
        </Link>
    );
}
